var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSkype(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_34",
    "data-name": "Rectangle 34",
    width: 16,
    height: 16,
    transform: "translate(672 7042)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_14",
    "data-name": "Mask Group 14",
    transform: "translate(-672 -7042)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "__TEMP__SVG__",
    transform: "translate(672.073 7042)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_54",
    "data-name": "Group 54"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M4.671,0A4.687,4.687,0,0,1,7.139.7a7.389,7.389,0,0,1,8.187,7.333,7.32,7.32,0,0,1-.072,1.026A4.668,4.668,0,0,1,8.81,15.356,7.389,7.389,0,0,1,.529,8.035a7.224,7.224,0,0,1,.08-1.081A4.658,4.658,0,0,1,4.67,0Zm.447,7.01a2.321,2.321,0,0,0,.729.769A7.07,7.07,0,0,0,7.1,8.432q.738.307,1.145.523a2.2,2.2,0,0,1,.615.448.766.766,0,0,1,.21.528.872.872,0,0,1-.335.723,1.573,1.573,0,0,1-.99.264A2.618,2.618,0,0,1,6.7,10.712q-.269-.12-.532-.253a1.284,1.284,0,0,0-.587-.15.717.717,0,0,0-.5.176.63.63,0,0,0-.2.491.8.8,0,0,0,.148.482,1.2,1.2,0,0,0,.456.354,5.113,5.113,0,0,0,2.212.419,4.554,4.554,0,0,0,1.624-.265,2.3,2.3,0,0,0,1.08-.8,2.216,2.216,0,0,0,.386-1.327,2.09,2.09,0,0,0-.279-1.1,2.53,2.53,0,0,0-.772-.792A7.2,7.2,0,0,0,8.486,7.3a1.05,1.05,0,0,0-.145-.058q-.513-.208-1.013-.447a1.827,1.827,0,0,1-.54-.387.727.727,0,0,1-.2-.508.805.805,0,0,1,.385-.723,1.76,1.76,0,0,1,.968-.247,2.917,2.917,0,0,1,.772.1,6.151,6.151,0,0,1,.8.293.813.813,0,0,0,.336.076A.6.6,0,0,0,10.3,5.2a.69.69,0,0,0,.18-.5.717.717,0,0,0-.17-.476,1.374,1.374,0,0,0-.556-.354A3.69,3.69,0,0,0,9.05,3.7a5.963,5.963,0,0,0-1.022-.078,4.53,4.53,0,0,0-1.536.258,2.71,2.71,0,0,0-1.174.784,1.91,1.91,0,0,0-.45,1.287A2.139,2.139,0,0,0,5.118,7.01Z",
    fill: "#114A65"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkype);
export default __webpack_public_path__ + "static/media/skype.b13c665183e205c1fdbbf329dd01f984.svg";
export { ForwardRef as ReactComponent };